import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import ROUTES from "../routes";

function Sidebar() {
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState(null);

    const toggleMenu = (menuName, e) => {
        e.preventDefault();
        setOpenMenu((prev) => (prev === menuName ? null : menuName));
    };

    const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

    return (
        <div className="deznav">
            <div className="deznav-scroll">
                <nav className="adminlte-nav">
                    <ul className="nav nav-pills nav-sidebar flex-column" role="menu">

                        {/* Dashboard */}
                        <li className={`nav-item ${isActive(ROUTES.DASHBOARD) && location.pathname === '/' ? 'active-item' : ''}`}>
                            <Link to={ROUTES.DASHBOARD} className="nav-link" onClick={() => setOpenMenu(null)}>
                                <i className="nav-icon fas fa-tachometer-alt"></i>
                                <p>Dashboard</p>
                            </Link>
                        </li>

                        {/* Brands */}
                        <li className={`nav-item ${isActive(ROUTES.BRANDS) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.BRANDS} className="nav-link">
                                <i className="nav-icon fas fa-trademark"></i>
                                <p>Brands</p>
                            </Link>
                        </li>

                        {/* Categories */}
                        <li className={`nav-item ${isActive(ROUTES.CATEGORIES) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.CATEGORIES} className="nav-link">
                                <i className="nav-icon fas fa-th-list"></i>
                                <p>Categories</p>
                            </Link>
                        </li>

                        {/* Products */}
                        <li className={`nav-item ${isActive(ROUTES.PRODUCTS) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.PRODUCTS} className="nav-link">
                                <i className="nav-icon fas fa-box"></i>
                                <p>Products</p>
                            </Link>
                        </li>


                        {/* Warehouse */}
                        <li className={`nav-item ${isActive(ROUTES.WAREHOUSE) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.WAREHOUSE} className="nav-link">
                                <i className="nav-icon fas fa-box"></i>
                                <p>Warehouse</p>
                            </Link>
                        </li>


                        {/* Testimonials */}
                        <li className={`nav-item ${isActive(ROUTES.TESTIMONIALS) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.TESTIMONIALS} className="nav-link">
                                <i className="nav-icon fas fa-star"></i>
                                <p>Testimonials</p>
                            </Link>
                        </li>

                        {/* FAQs */}
                        <li className={`nav-item ${isActive(ROUTES.FAQ) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.FAQ} className="nav-link">
                                <i className="nav-icon fas fa-question-circle"></i>
                                <p>FAQs</p>
                            </Link>
                        </li>

                        {/* Blogs */}
                        <li className={`nav-item ${isActive(ROUTES.BLOGS) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.BLOGS} className="nav-link">
                                <i className="nav-icon fas fa-blog"></i>
                                <p>Blogs</p>
                            </Link>
                        </li>

                        {/* Trade Accounts */}
                        <li className={`nav-item ${isActive(ROUTES.TRADE_ACCOUNTS) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.TRADE_ACCOUNTS} className="nav-link">
                                <i className="nav-icon fas fa-money-bill"></i>
                                <p>Trade Accounts</p>
                            </Link>
                        </li>

                        {/* CTA Requests */}
                        <li className={`nav-item ${isActive(ROUTES.CTA) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.CTA} className="nav-link">
                                <i className="nav-icon fas fa-hand-pointer"></i>
                                <p>CTA Requests</p>
                            </Link>
                        </li>

                        {/* Leads */}
                        <li className={`nav-item ${isActive(ROUTES.LEADS) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.LEADS} className="nav-link">
                                <i className="nav-icon fas fa-users"></i>
                                <p>Leads</p>
                            </Link>
                        </li>

                        {/* Reviews */}
                        <li className={`nav-item ${isActive(ROUTES.REVIEW) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.REVIEW} className="nav-link">
                                <i className="nav-icon fas fa-comment-dots"></i>
                                <p>Reviews</p>
                            </Link>
                        </li>

                        {/* Orders */}
                        <li className={`nav-item ${isActive(ROUTES.ORDERS) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.ORDERS} className="nav-link">
                                <i className="nav-icon fas fa-shopping-cart"></i>
                                <p>Orders</p>
                            </Link>
                        </li>

                        {/* Payment Links */}
                        <li className={`nav-item ${isActive(ROUTES.PAYMENT_LINKS) ? 'active-item' : ''}`}>
                            <Link to={ROUTES.PAYMENT_LINKS} className="nav-link">
                                <i className="nav-icon fas fa-link"></i>
                                <p>Payment Links</p>
                            </Link>
                        </li>

                        {/* Settings */}
                        <li className={`nav-item ${isActive('/settings') ? 'active-item' : ''}`}>
                            <Link to={ROUTES.SETTINGS_GENERAL} className="nav-link" onClick={() => setOpenMenu(null)}>
                                <i className="nav-icon fas fa-cog"></i>
                                <p>Settings</p>
                            </Link>
                        </li>

                        {/* CMS — treeview with submenu */}
                        <li className={`nav-item has-treeview ${openMenu === 'cms' ? 'menu-open' : ''}`}>
                            <a
                                href="#/"
                                className="nav-link"
                                onClick={(e) => toggleMenu('cms', e)}
                            >
                                <i className="nav-icon fas fa-file-alt"></i>
                                <p>
                                    CMS
                                    <i className="fas fa-angle-left right-arrow"></i>
                                </p>
                            </a>
                            <ul className="nav nav-treeview">
                                <li className="nav-item">
                                    <Link to="/cms/home" className={`nav-link ${location.pathname === '/cms/home' ? 'active' : ''}`}>
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>Home</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cms/about" className={`nav-link ${location.pathname === '/cms/about' ? 'active' : ''}`}>
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>About</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cms/contact_us" className={`nav-link ${location.pathname === '/cms/contact_us' ? 'active' : ''}`}>
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>Contact Us</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cms/functionality" className={`nav-link ${location.pathname === '/cms/functionality' ? 'active' : ''}`}>
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>Functionality</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cms/resources" className={`nav-link ${location.pathname === '/cms/resources' ? 'active' : ''}`}>
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>Resources</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cms/product_list" className={`nav-link ${location.pathname === '/cms/product_list' ? 'active' : ''}`}>
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>Product List</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cms/product_detail" className={`nav-link ${location.pathname === '/cms/product_detail' ? 'active' : ''}`}>
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>Product Detail</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cms/cart" className={`nav-link ${location.pathname === '/cms/cart' ? 'active' : ''}`}>
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>Cart</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cms/checkout" className={`nav-link ${location.pathname === '/cms/checkout' ? 'active' : ''}`}>
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>Checkout</p>
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cms/thankyou" className={`nav-link ${location.pathname === '/cms/thankyou' ? 'active' : ''}`}>
                                        <i className="far fa-circle nav-icon"></i>
                                        <p>Thank You</p>
                                    </Link>
                                </li>
                            </ul>
                        </li>

                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default Sidebar;
